<script lang="ts" setup>
import { getCmsImage } from '@/composables/useCms';

interface BrandLogo {
  title?: string;
  logo?: { url?: string }[];
}

defineProps<{
  title?: string;
  brandLogo?: BrandLogo[];
}>();
</script>

<template>
  <div class="py-8">
    <VContainer>
      <h2 v-if="title" class="text-2xl lg:text-3xl 2xl:text-4xl mb-6 font-bold text-gray-900">
        {{ title }}
      </h2>

      <div v-if="brandLogo?.length" class="flex flex-wrap gap-4 items-center justify-center">
        <div
          v-for="(logo, index) in brandLogo"
          :key="`brand-static-logo-${index}`"
          class="flex h-24 items-center justify-center px-4"
        >
          <NuxtImg
            v-if="logo.logo?.length"
            :src="getCmsImage(logo.logo)"
            :alt="logo.title || title || 'Brand logo'"
            :title="logo.title || title || 'Brand logo'"
            class="max-h-14 w-auto object-contain"
            loading="lazy"
            format="webp"
          />
        </div>
      </div>
    </VContainer>
  </div>
</template>
